import { render, staticRenderFns } from "./WidgetHeader.html?vue&type=template&id=44ba1c4c&scoped=true&external"
import script from "./WidgetHeader.ts?vue&type=script&lang=ts&external"
export * from "./WidgetHeader.ts?vue&type=script&lang=ts&external"
import style0 from "./WidgetHeader.scss?vue&type=style&index=0&id=44ba1c4c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ba1c4c",
  null
  
)

export default component.exports